var map = {
	"./google-play-badge-da-DK.svg": 6200,
	"./google-play-badge-de-DE.svg": 81626,
	"./google-play-badge-en-GB.svg": 5451,
	"./google-play-badge-en-US.svg": 5843,
	"./google-play-badge-es-ES.svg": 53700,
	"./google-play-badge-es-MX.svg": 58215,
	"./google-play-badge-fr-FR.svg": 63660,
	"./google-play-badge-it-IT.svg": 1474,
	"./google-play-badge-nb-NO.svg": 47153,
	"./google-play-badge-nl-NL.svg": 41256,
	"./google-play-badge-pl-PL.svg": 39488,
	"./google-play-badge-pt-BR.svg": 12300,
	"./google-play-badge-pt-PT.svg": 11920,
	"./google-play-badge-sv-SE.svg": 401
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;